<script setup lang="ts">
import Button from '@components/global/button.vue'
</script>

<template>
	<section class="container">
		<div class="relative mt-5 flex w-full flex-col-reverse items-center gap-5 lg:mt-20 lg:flex-row lg:items-end lg:gap-20">
			<div class="w-full lg:w-half">
				<img src="https://cdn.projectether.co/images/home-page/home-fashion.png" class="" alt="" />
			</div>
			<div class="d1 relative flex flex-col items-center gap-4 text-center uppercase text-default lg:items-start lg:gap-2 lg:text-left">
				<span class="font-heading-regular">
					et
					<span class="font-heading-bold">h</span>
					<span class="font-heading-light">er</span>
				</span>
				<span class="text-purple-base">
					<span class="font-heading-regular">f</span>
					<span class="font-heading-bold">ashio</span>
					<span class="font-heading-regular">n</span>
				</span>
				<p class="md fashion-text-dot">At ETHER, we will combine our own original characters alongside our community to create finely detailed accessories and garments.</p>
				<Button class="default mt-4" icon="fa-solid fa-arrow-up-right" :to="{ name: 'shop-list' }">explore shop</Button>
			</div>
		</div>
	</section>
	<div class="mb-10 w-full">
		<img src="https://cdn.projectether.co/images/home-page/home-fashion-separator.svg" alt="" class="w-full" />
	</div>
</template>

<style scoped>
.container {
	@apply pb-0;
}

.fashion-text-dot::after {
	position: absolute;
	top: 16px;
	right: 16px;
	display: block;
	width: 3px;
	height: 3px;
	background: #9e76b2;
}

.fashion-text-dot {
	@apply max-w-[250px] rounded-tr-[16px] border-r-default border-t-default text-center normal-case after:content-none lg:absolute lg:right-0 lg:top-0 lg:border-r lg:border-t lg:pr-[20px] lg:pt-[20px] lg:text-start lg:after:content-[''];
}
</style>
